import React from 'react'; 
import {getData } from '../../../core/HttpAction';  
import Table from '../../../core/Table'; 
import {PdfGenrate} from '../../../core/Pdf';  
import {exportCSVFile,dataUri} from '../../../core/CsvDownload';  
 
const Url='/fine-report';

const CellColumn=({row,index})=>{  
    return row.paid?'Paid':'Not Paid'; 
}; 

const CustomButton=({props})=>{   
    return<button style={{float:'left'}} type="button" onClick={()=>props.download()}   className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Download CSV</button>;
}; 
 
const columns=[
    {
        key:'name',
        displayName:'Name', 
    },
    {
        key:'email',
        displayName:'Email Id', 
        styles:{width:'8%'}
    },
    {
        key:'book_name',
        displayName:'Book Name',
        styles:{width:'20%'}
    },
    /*{
        key:'access_code',
        displayName:'Access Code',
    },*/
    {
        key:'issue_date',
        displayName:'Issued Date', 
    },
    /*{
        key:'no_of_days',
        displayName:'No of Days', 
    },*/
    {
        key:'amount',
        displayName:'Amount Per Day', 
        styles:{width:'5%'}
    },
    {
        key:'total_amount',
        displayName:'Total Amount',
        styles:{width:'5%'} 
    },
    {
        key:'paid',
        displayName:'paid Status', 
        Cell:CellColumn
    },    
]; 
class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
            }, 
            data:[],
            pdfData:[],
            preloader:true
        }; 
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData=()=>{
        getData(Url,this.state.params).then((res)=>{ 
            let data=res.data;
            /*  if(data)
                this.make_base(data); */
            this.setState({data:data,preloader:false}); 
        });
    }

    handleFetch=(params)=>{
        this.setState({params:{...this.state.params,...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    download=()=>{
        const fileName ='qr-code';
        const {data}=this.state.data;
        const rows=data.map((val,i)=>{
            return{ 
                name:val.name,
                email:val.email,
                book_name:val.book_name,
                access_code:val.access_code?val.access_code:'',
                issue_date:val.issue_date,
                no_of_days:val.no_of_days,
                amount:val.amount,
                total_amount:val.total_amount,
                paid:val.paid?'Paid':'Not Paid', 
            };
        }); 
        var headers = {
            name: 'Name'.replace(/,/g, ''),
            email: 'Email Id', 
            book_name: 'Book Name', 
            access_code: 'Access Code', 
            issue_date: 'Issued Date', 
            no_of_days: 'No of Days', 
            amount: 'Amount', 
            total_amount: 'Total Amount', 
            paid: 'paid Status', 
        };
           
        rows.unshift(headers);
        exportCSVFile(rows, fileName); 
    }
 
    /*     download=()=>{
        const pdfArray=[
            {
                index:'qr-code',
                data:document.getElementById('pdfContentQRCODE'),
                imgElement:document.querySelectorAll('#pdfContentQRCODE tr img')
            } 
        ]; 
        PdfGenrate({pdfArray,filename:`${this.state.params.type}-qr-code`});  

    } */
    
    custonAction=(e)=> {
        const type=e.target.value?e.target.value:'';
        this.setState({params:{...this.state.params,type},preloader:true},()=>{
            this.fetchData();
        }); 
    } 
 
    render() {
        let {preloader,data}=this.state; 
        return ( 
            <div> 
                <Table
                    data={data}
                    handleFetch={this.handleFetch}
                    preloader={preloader}
                    permission="fine-report"
                    title="Fine Report"
                    columns={columns}
                    primaryKey="qr_code_id"
                    callPrint={this.callPrint}
                    download={this.download} 
                    CustomButton={CustomButton}
                /> 
            </div>
        );
    }
}
export default Reports; 


// WEBPACK FOOTER //
// ./src/components/Reports/FineReport/fineReport.js